import React from 'react';
import { List } from 'antd';

function AdnList({ header, data, renderItem, style }) {
    return <div>
        <List
            style={style}
            header={header}
            bordered
            dataSource={data}
            renderItem={renderItem}
        />
    </div>;
}

export default AdnList;

